var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10.1868C18.3333 9.63824 18.2836 9.11741 18.1985 8.61046H10.1809V11.7424H14.7715C14.5657 12.7702 13.9626 13.6382 13.0686 14.2285V16.3119H15.8074C17.4109 14.8605 18.3333 12.7216 18.3333 10.1868Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1809 18.3327C12.4797 18.3327 14.4025 17.5827 15.8074 16.3119L13.0686 14.2285C12.3024 14.7285 11.3303 15.0341 10.1809 15.0341C7.96008 15.0341 6.07985 13.5688 5.40581 11.5896H2.58191V13.7355C3.97967 16.4577 6.85323 18.3327 10.1809 18.3327Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40581 11.5896C5.22843 11.0896 5.13619 10.5549 5.13619 9.99935C5.13619 9.44379 5.23552 8.90907 5.40581 8.40907V6.26324H2.58191C2.0001 7.38824 1.66663 8.65213 1.66663 9.99935C1.66663 11.3466 2.0001 12.6105 2.58191 13.7355L5.40581 11.5896Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1809 4.96463C11.4367 4.96463 12.5578 5.38824 13.4447 6.21463L15.8713 3.83963C14.4025 2.4924 12.4797 1.66602 10.1809 1.66602C6.85323 1.66602 3.97967 3.54102 2.58191 6.26324L5.40581 8.40907C6.07985 6.4299 7.96008 4.96463 10.1809 4.96463Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.2adc7e87ccb9b97c9bbf0a458ce34d37.svg";
export { ForwardRef as ReactComponent };